import { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { SetCourseSortOrder } from "../../actions/superUserMutations";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useQueryClient } from "@tanstack/react-query";

export default function SetCourseOrderInLicenseModal({
  isOpen,
  toggle,
  courses,
  licenseId,
}) {
  const queryClient = useQueryClient();
  const [sortedCourses, setSortedCourses] = useState(courses);

  useEffect(() => {
    setSortedCourses([...courses]);
  }, [courses]);

  const mutateSetCourseOrder = useMutation({ mutationFn: SetCourseSortOrder });

  const handleUpdateCoursesList = () => {
    queryClient.invalidateQueries({ queryKey: ["FetchAdminCourses"] });
    queryClient.invalidateQueries({ queryKey: ["FetchOrphanCourses"] });
  };

  const handleSaveOrder = () => {
    let postObject = {
      programId: licenseId,
      orderedCourseIds: sortedCourses.map((course) => course.id),
    };

    mutateSetCourseOrder.mutate(postObject, {
      onSuccess: (data) => {
        if (data && data.status > 199 && data.status < 300) {
          toast.success("Ordning sparad");
          handleUpdateCoursesList();
        } else {
          toast.warn(data);
        }
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data);
      },
    });
    toggle();
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...sortedCourses];

    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);

    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

    setSortedCourses(updatedList);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader>
        <p>
          <FormattedMessage id="ChangeOrderForCoursesInProgram" />
        </p>
        <small className="text-muted">
          <FormattedMessage id="DragAndDropToChangeOrder" />
        </small>
      </ModalHeader>
      <ModalBody className="mx-auto">
        <DragDropContext onDragEnd={handleDrop}>
          <Droppable droppableId="list-container">
            {(provided) => (
              <div
                className="list-container"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {sortedCourses.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={"draggableItem" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        className="draggable--item"
                        ref={provided.innerRef}
                        {...provided.dragHandleProps}
                        {...provided.draggableProps}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "350px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.name}
                        </span>
                        <DragIndicatorIcon className="drag--indicator" />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex">
          <Button
            onClick={toggle}
            className="pull-right mx-1"
            color="secondary"
            outline
          >
            <FormattedMessage id="Cancel" />
          </Button>

          <Button
            onClick={() => handleSaveOrder()}
            className="pull-right mx-1"
            color="primary"
            outline
          >
            <FormattedMessage id="Save" />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
